<template>
  <div
    ref="colorpicker"
    class="base-colorpicker-container d-flex flex-row"
    :class="{ 'picker-open': displayPicker }"
  >
    <base-input :label="label" :addonRightTooltip="tooltipText" :addonRightIcon="icon" addonLeftIcon="fas fa-circle"
      :addonLeftColor="colorValue" type="text" class="w-100" style="border: none; border-radius: 0px;"
      v-model="colorValue" @focus="showPicker()" @input="updateFromInput" :readOnly="readOnly" />

    <div v-if="isColorPicker">
      <div class="input-group-append ml-0 mb">
        <span class="input-group-text">
          <i @click="alterarTodosBotaoClickColorPicker()" class="fas fa-list-alt"></i>
        </span>
      </div>
    </div>

    <div
      v-if="displayPicker"
      class="color-picker-popover"
      :class="[`popover-${pickerPlacement.vertical}`, `popover-${pickerPlacement.horizontal}`]"
    >
      <chrome-picker :value="colors" @input="updateFromPicker" />
    </div>
  </div>
</template>

<script>
import VueColor from 'vue-color';
import { rootCssVar } from '../../utils/rootCssVar';

const Chrome = VueColor.Chrome;

export default {
  name: 'base-colorpicker',
  props: {
    color: {
      default: '',
    },

    label: {
      type: String,
      default: '[label]',
    },

    tooltipText: {
      type: String,
      default: '',
    },

    icon: {
      type: String,
      default: '',
    },
    
    isColorPicker: {
      type: Boolean,
      default: true,
    },

    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  components: { 'chrome-picker': Chrome },
  data() {
    return {
      colors: {
        hex: '',
      },
      colorValue: '',
      displayPicker: false,
      pickerPlacement: {
        vertical: 'below',
        horizontal: 'left',
      },
    };
  },
  mounted() {
    const padrao = rootCssVar('--qr-modules-dark');
    this.setColor(this.color || padrao);
  },
  beforeDestroy() {
    this.removeOutsideListeners();
  },

  methods: {
    alterarTodosBotaoClickColorPicker() {
      this.$emit('alterarTodosBotaoClickColorPicker');
    },
    setColor(color) {
      if (color == null || color === '') {
        return;
      }
      this.updateColors(color);
      this.colorValue = color;
    },
    updateColors(color) {
      if (color == null || color === '') {
        return;
      }
      if (color.slice(0, 1) == '#') {
        this.colors = { hex: color };
      } else if (color.slice(0, 4) == 'rgba') {
        var rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(','),
          hex =
            '#' +
            ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2]))
              .toString(16)
              .slice(1);
        this.colors = {
          hex: hex,
          a: rgba[3],
        };
      }
    },
    showPicker() {
      if (this.readOnly) return;
      this.displayPicker = true;
      this.addOutsideListeners();
      this.$nextTick(this.updatePickerPlacement);
    },
    hidePicker() {
      this.removeOutsideListeners();
      this.displayPicker = false;
    },
    togglePicker() {
      this.displayPicker ? this.hidePicker() : this.showPicker();
    },
    updateFromInput() {
      this.updateColors(this.colorValue);
    },
    updateFromPicker(color) {
      this.colors = color;
      if (color.rgba.a == 1) {
        this.colorValue = color.hex;
      } else {
        this.colorValue =
          'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
      }
    },
    addOutsideListeners() {
      document.addEventListener('mousedown', this.documentPointerDown, true);
      document.addEventListener('touchstart', this.documentPointerDown, true);
    },
    removeOutsideListeners() {
      document.removeEventListener('mousedown', this.documentPointerDown, true);
      document.removeEventListener('touchstart', this.documentPointerDown, true);
    },
    documentPointerDown(event) {
      const element = this.$refs.colorpicker;
      if (element && !element.contains(event.target)) {
        this.hidePicker();
      }
    },
    updatePickerPlacement() {
      const element = this.$refs.colorpicker;
      if (!element) return;

      const rect = element.getBoundingClientRect();
      const pickerWidth = 225;
      const pickerHeight = 245;
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const spaceBelow = viewportHeight - rect.bottom;
      const spaceAbove = rect.top;

      this.pickerPlacement = {
        vertical: spaceBelow < pickerHeight + 8 && spaceAbove > spaceBelow ? 'above' : 'below',
        horizontal: viewportWidth - rect.left < pickerWidth + 8 ? 'right' : 'left',
      };
    },
  },
  watch: {
    colorValue(val) {
      if (val) {
        this.updateColors(val);
        this.$emit('input', val);
      }
    },
  },
};
</script>

<style scoped>
.base-colorpicker-container {
  position: relative;
  height: 2.5rem;
  overflow: visible;
  background-color: var(--lp-white-20);
}

.base-colorpicker-container.picker-open {
  z-index: 1100;
}

.color-picker-popover {
  position: absolute;
  z-index: 1101;
}

.color-picker-popover.popover-below {
  top: calc(100% + 4px);
}

.color-picker-popover.popover-above {
  bottom: calc(100% + 4px);
}

.color-picker-popover.popover-left {
  left: 0;
}

.color-picker-popover.popover-right {
  right: 0;
}

.color-picker-popover ::v-deep .vc-chrome {
  position: static;
  inset: auto;
  z-index: auto;
}
</style>
